'use client'

import { Image } from '@vinted/web-ui'
import { useIntl } from 'react-intl'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'
import { Hostname } from '@marketplace-web/vinted-context/construct-headers-util'
import { clickEvent } from '@marketplace-web/web-to-app/web-to-app-data'

enum Platform {
  Android = 'android',
  Ios = 'ios',
}

const url: Record<Platform, string> = {
  [Platform.Android]: `https://${Hostname.Fr}/l/app-android-landing`,
  [Platform.Ios]: `https://${Hostname.Fr}/l/app-ios-landing`,
}
const clickTarget: Record<Platform, Parameters<typeof clickEvent>[0]['target']> = {
  [Platform.Android]: 'download_android_app',
  [Platform.Ios]: 'download_ios_app',
}

type Props = {
  platform: Platform
}

const AppButton = ({ platform }: Props) => {
  const { track } = useTracking()
  const translate = useTranslate('app_store_buttons')
  const { locale } = useIntl()
  const asset = useAsset(`/assets/app-badges/${platform}`)

  const language = locale.split('-')[0]

  function handleClick() {
    track(
      clickEvent({
        target: clickTarget[platform],
      }),
    )
  }

  return (
    <a href={url[platform]} target="_blank" rel="noopener noreferrer" onClick={handleClick}>
      <Image
        src={asset(`${language!}.svg`)}
        fallbackSrc={asset('/default.svg')}
        alt={translate(`a11y.${platform}`)}
      />
    </a>
  )
}

AppButton.Platform = Platform

export default AppButton
